<div class="breadcrumbs" >
  <div class="breadcrumb" *ngFor="let breadcrumb of breadcrumbObjects; index as i" >
    <a [ngClass]="{'last': (i === (breadcrumbObjects.length - 1))}" [routerLink]="breadcrumb.url" [queryParams]="breadcrumb.queryParams" class="kbody-small name">{{ breadcrumb.name }}</a>
    <span *ngIf="i !== (breadcrumbObjects.length - 1)" class="kbody-small break">/</span>
  </div>
</div>
